import { Provider } from "react-redux";
import CompleteTodoFooter from "./components/CompleteTodoFooter";
import CompleteTodoHeader from "./components/CompleteTodoHeader";
import CompleteTodoList from "./components/CompleteTodoList";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Navbar from "./components/Navbar";
import TodoList from "./components/TodoList";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <div className="grid place-items-center bg-blue-100 min-h-screen px-6 font-sans py-20">
        <Navbar />

        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white">
          <Header />
          <hr className="mt-4" />
          <TodoList />
          <hr className="mt-4" />
          <Footer />
        </div>

        <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-10">
          <CompleteTodoHeader />
          <hr className="mt-1" />
          <CompleteTodoList />
          <hr className="mt-4" />
          <CompleteTodoFooter />
        </div>
      </div>
    </Provider>
  );
}

export default App;
